<template>
  <div>
    <template v-if="loading">
      <div class="spinner text-xs-center mb-5 mt-5">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </template>
    <template v-else>
      <form @click="bankDuplicates = false">
        <v-layout v-if="!isPayment">
          <v-flex>
            <h3 v-if="isMetaVerifySlip" class="primary--text pa-2">
              {{ $t('auto_verify_slip_meta') }}
            </h3>
            <h3 v-else class="primary--text pa-2">{{ $t('auto_verify_slip') }}</h3>
          </v-flex>
          <v-flex>
            <div class="text-xs-right">
              <v-btn flat fab small @click="onCancleDialog">
                <v-icon>close</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
        <div
          class="form-control intent-item z-border-red"
          style="padding: 10px 15px 0px;"
          v-for="(item, index) in bankVerifyData"
          :key="`verifyData_${item.id}${index}`"
        >
          <intent-prefill-verify-slip-form
            v-if="item"
            :isMetaVerifySlip="isMetaVerifySlip"
            :index="index"
            v-model="bankVerifyData[index]"
            :data.sync="bankVerifyData"
            @deleteDataBankVerify="deleteDataBankVerify"
          >
          </intent-prefill-verify-slip-form>
        </div>
        <template
          v-if="
            isMetaVerifySlip ||
              (bankVerifyData.length < getPackageConfig().verifySlip &&
                bankVerifyData[0] &&
                bankVerifyData[0].typeAccount &&
                bankVerifyData[0].typeAccount.value !== 'all')
          "
        >
          <a
            v-if="bankVerifyData.length < getPackageConfig().verifySlip"
            href="javascript:void(0);"
            class="mt-2"
            @click="addPrefillVerify"
          >
            <div class="add-conversation text-xs-center">
              <i class="fa fa-plus middle"></i>
              <template v-if="isMetaVerifySlip">
                {{ $t('add_account_meta') }}
              </template>
              <template v-else>
                {{ $t('add_account') }}
              </template>
            </div>
          </a>
          <div class="text-xs-right">
            {{ bankVerifyData.length }} / {{ getPackageConfig().verifySlip }}
          </div>
        </template>
        <div class="text-xs-center mt-3">
          <span v-if="bankDuplicates" style="color: red">เลขบัญชีซ้ำ กรุณากรอกใหม่อีกครั้ง</span>
        </div>
      </form>
      <div class="text-xs-center">
        <v-btn outline color="grey" @click="onCancleDialog">{{ $t('cancel') }}</v-btn>
        <v-btn depressed color="primary" @click="submitPrefillVerify">{{ $t('Save') }}</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import IntentPrefillVerifySlipForm from './IntentPrefillVerifySlipForm'
import { mapGetters } from 'vuex'
export default {
  props: ['dialogVerify', 'dataVerifySlip', 'isPayment', 'isMetaVerifySlip'],
  data: function() {
    return {
      bankDuplicates: false,
      bankVerifyData: this.dataVerifySlip,
      cacheBankVerifyData: null,
      currentView: 'payment_method',
      loading: false
    }
  },
  components: {
    IntentPrefillVerifySlipForm
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  mounted() {
    const vm = this
    vm.cacheBankVerifyData = JSON.stringify(vm.bankVerifyData)
    if (
      vm.isMetaVerifySlip &&
      vm.$store.state.pageMetaVerifySlip.includes(vm.$store.state.selectedBot.pageid)
    ) {
      vm.getVerifyMeta()
    } else {
      if (vm.bankVerifyData.length === 0) {
        vm.addPrefillVerify()
      }
    }
  },
  provide() {
    return { parentValidatorVerify: this.$validator }
  },
  methods: {
    async onCancleDialog() {
      const vm = this
      let result = await vm.$swal.fire({
        title: vm.$t('do_you_want_cancel'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        if (
          vm.isMetaVerifySlip &&
          (vm.bankVerifyData.length === 0 ||
            vm.cacheBankVerifyData.length === 0 ||
            !vm.cacheBankVerifyData)
        ) {
          vm.$emit('clearVerify')
        }
        vm.bankVerifyData = JSON.parse(vm.cacheBankVerifyData)
        vm.$emit('update:dataVerifySlip', vm.bankVerifyData)
        vm.$emit('update:dialogVerify', false)
      }
    },
    insertPrefill: function(value) {
      this.$emit('onAddPrefill', value)
    },
    openDialog() {
      const vm = this
      vm.dialog = true
      vm.$emit('update:dialogVerify', true)
    },
    addPrefillVerify() {
      const vm = this
      if (vm.bankVerifyData.length < 10) {
        vm.bankVerifyData.push({
          id: vm.isMetaVerifySlip ? `meta_${dayjs().format('x')}` : dayjs().format('x'),
          typeAccount: { value: 'transfer', label: 'Transfer' },
          bankAccountNo: '',
          bankName: '004',
          keyword: []
        })
      }
    },
    async submitPrefillVerify() {
      const vm = this
      const result = await vm.$validator.validateAll()
      if (result) {
        if (vm.isMetaVerifySlip) {
          if (
            vm.bankVerifyData.length === 0 ||
            vm.cacheBankVerifyData.length === 0 ||
            !vm.cacheBankVerifyData
          ) {
            vm.$emit('update:dialogVerify', false)
            vm.$emit('clearVerify')
          }
          vm.savePrefillVerifyByMeta()
        } else {
          vm.savePrefillVerify()
        }
      }
    },
    async savePrefillVerifyByMeta() {
      const vm = this
      try {
        let result = await Promise.all(
          vm.bankVerifyData.map(item => {
            if (item.id.includes('meta')) {
              const data = {
                account_holder_name: item.name,
                bank_code: item.bankName,
                bank_account_number: item.bankAccountNo
              }
              return vm.postInvoiceAccessBankAccount(data)
            }
          })
        )
        if (result) {
          vm.$store.dispatch('getVerifyMeta', vm)
          vm.$emit('update:dialogVerify', false)
          vm.$emit('onAddPrefillMeta', vm.bankVerifyData)
          vm.$emit('onClickVerifySlip')
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getVerifyMeta() {
      const vm = this
      vm.loading = true
      await vm.$store.dispatch('getVerifyMeta', vm)
      vm.bankVerifyData = vm.$store.state.metaVerifySlip
      vm.loading = false
    },
    async postInvoiceAccessBankAccount(data) {
      const vm = this
      try {
        const response = await vm.post(
          `${vm.selectedBot.pageid}/invoice_access_bank_account?access_token=${vm.selectedBot.page_access_token}`,
          data,
          {
            custom_url: 'https://graph.facebook.com/v16.0/'
          }
        )
        if (response) {
          return response
        }
      } catch (error) {
        console.error(error)
      }
    },
    async savePrefillVerify() {
      const vm = this
      vm.$emit('onClickVerifySlip')
      let info = ''
      const lookup = vm.bankVerifyData.reduce((a, e) => {
        a[`${e.bankAccountNo}${e.bankName}`] = ++a[`${e.bankAccountNo}${e.bankName}`] || 0
        return a
      }, {})
      let findDuplicates = vm.bankVerifyData.filter(e => lookup[`${e.bankAccountNo}${e.bankName}`])
      vm.bankVerifyData.forEach((item, index) => {
        if (item.typeAccount && item.typeAccount.value === 'promptpay') {
          info += `promptpay|${item.bankAccountNo}`
        } else {
          info += `${item.bankName}|${item.bankAccountNo}`
        }
        if (item.keyword && item.keyword.length) {
          let keyword = []
          item.keyword.forEach(val => {
            if (val && val.text) {
              keyword.push(val.text)
            }
          })
          info += `|${keyword.join('!')}`
        }
        if (vm.bankVerifyData.length !== index + 1) {
          info += '^'
        }
      })
      let text = '{verify_slip.image}'
      if (
        vm.bankVerifyData &&
        vm.bankVerifyData.length > 0 &&
        vm.bankVerifyData[0].typeAccount &&
        vm.bankVerifyData[0].typeAccount.value !== 'all'
      ) {
        text = `{verify_slip.bank_info=${info},{verify_slip.image}`
      }
      if (findDuplicates.length === 0) {
        vm.$emit('onAddPrefill', text)
        vm.$emit('update:dialogVerify', false)
      } else {
        vm.bankDuplicates = true
      }
    },
    async deleteDataBankVerify(value) {
      const vm = this
      if (vm.isMetaVerifySlip && !value.id.includes('meta')) {
        const result = await vm.$swal.fire({
          title: this.$t('Do you want to delete xxxxxx{name}?', {
            name: value.bankAccountNo
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        if (result.value) {
          const response = await vm.deleteBankVerify(value.id)
          if (response) {
            vm.bankVerifyData = vm.bankVerifyData.filter(item => {
              return item !== value
            })
            vm.$store.dispatch('getVerifyMeta', vm)
            vm.cacheBankVerifyData = JSON.stringify(vm.bankVerifyData)
            vm.$emit('update:dataVerifySlip', vm.bankVerifyData)
          }
        }
      } else {
        vm.bankVerifyData = vm.bankVerifyData.filter(item => {
          return item !== value
        })
        vm.$emit('update:dataVerifySlip', vm.bankVerifyData)
      }
    },
    async deleteBankVerify(bank_id) {
      const vm = this
      try {
        const response = await vm.delete(
          `${vm.selectedBot.pageid}/invoice_access_bank_account?access_token=${vm.selectedBot.page_access_token}&bank_id=${bank_id}`,
          {
            custom_url: 'https://graph.facebook.com/v16.0/'
          }
        )
        if (response) {
          return response
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentPrefillVerifySlip.vue